/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './bootstrap';

import InputMask from 'inputmask/dist/inputmask/inputmask.date.extensions';

window.InputMask = InputMask;
// Not using VUE.

// window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));
//
// const app = new Vue({
//     el: '#app'
// });

/* Start of BOC global app code. */
$(function () {
    $('#flash-overlay-modal').modal();

    $('.alert').not('.alert-important').fadeOut(4000);

    // Highlight validation errors on most pages (NOT orders page, handled in orders class)
    if (typeof (error_keys) != 'undefined') {
        for (let i = 0; i < error_keys.length; i++) {
            $('[name="' + error_keys[i] + '"]').css('background', '#ffff99');
            $('#' + error_keys[i]).css('background', '#ffff99');
        }
    }

    $('.print').on('click', function () {
        window.print();
    });
    $('.deleteitem').on('click', function () {
        return confirm('Are you sure you want to delete this item?');
    });
    $('.archiveitem').on('click', function () {
        return confirm('Are you sure you want to archive this item?');
    });
    $('.deleteforever').on('click', function () {
        return confirm("WARNING!!!\n\nAre you sure you want to delete this item forever?\n\nDeleting this item from the trash could leave orders that include it with missing data. This action cannot be undone.");
    });

    /*Timeout - redirect user to login after 1 hour and 55 minutes. */
    // Increment the idle time counter every minute.
    // var idleInterval = setInterval(timerIncrement, 60000); //check once a minute

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $(document).on('scroll click keydown', function () {
        idleTime = 0;
    });

    var pathname = window.location.pathname;
    var noTimeoutPaths = ['/clinics/create/selfreg', '/clinics/create'];
    if ($.inArray(pathname, noTimeoutPaths) === -1) {
        setInterval(timerIncrement, 60000);
    }
});

var idleTime = 0;

function timerIncrement() {
    idleTime = idleTime + 1;
    if (idleTime === 115) { // 115 minutes
        $('#timeoutModal').modal();
    }
    if (idleTime === 120) {
        window.location.href = "/logout";
    }
}
